import { UPDATE_TOKEN, HANDLE_TOKEN_ERROR } from '../constants/ActionTypes';

const initialState = {
  loading: true,
  loaded: false,
  fail: false,
  token: '',

};
const run = {};

run[HANDLE_TOKEN_ERROR] = (state, action) => {
  return Object.assign({}, state, {
    loading: false,
    loaded: true,
    token: action.response,
    fail: true,
  });
};

run[UPDATE_TOKEN] = (state, action) => {
  return Object.assign({}, state, {
    loading: false,
    loaded: true,
    token: action.response,
    fail: false,
  });
};

const tokenReducer = (state = initialState, action) => {
  if (action.type in run) {
    return run[action.type](state, action);
  }

  return state;
};

export default tokenReducer;



// WEBPACK FOOTER //
// ./src/reducers/token.js